export const materialLabel = "Material";
export const materialName = "Material Name";
export const addMaterialLabel = "Add Material";
export const editMaterialLabel = "Edit Material";
